import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import{ refreshToken } from "../views/AuthModals/SignIn/refreshToken";

const baseQuery = fetchBaseQuery({
  baseUrl: "",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    } else {
    }
    return headers;
  },
});

function hasOriginalStatus(
  error: FetchBaseQueryError
): error is FetchBaseQueryError & { originalStatus: number } {
  return (error as any).originalStatus !== undefined;
}

const customFetchBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (
    result.error &&
    hasOriginalStatus(result.error) &&
    result.error.originalStatus === 401
  ) {
    const newToken = await refreshToken();

    if (newToken) {
      const headers = (args as FetchArgs).headers;
      if (headers instanceof Headers) {
        headers.set("Authorization", `Bearer ${newToken}`);
      } else if (Array.isArray(headers)) {
        (args as FetchArgs).headers = [
          ...headers,
          ["Authorization", `Bearer ${newToken}`],
        ];
      } else {
        (args as FetchArgs).headers = {
          ...headers,
          Authorization: `Bearer ${newToken}`,
        };
      }
      result = await baseQuery(args, api, extraOptions);
    } else {
      window.location.href = "/sign-in";
      localStorage.clear();
    }
  } else {
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: customFetchBaseQuery,
  tagTypes: ["Restaurant", "Order"],
  endpoints: (builder) => ({}),
});
